import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const ipSlice = createSlice({
  name: 'user-ip',
  initialState: {
    value: '',
  },
  reducers: {
    setUserIp: (state, action: PayloadAction<string>) => {
      state.value = action.payload;
    },
  },
});

export const { setUserIp } = ipSlice.actions;

export default ipSlice.reducer;
